import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import moment from 'moment';
import { getGoodsVisibleList, deleteGoodsVisibleByid } from '@/services/product/goodsVisible.js';
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("./i18n-visible"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'productNo',
      title: this.$t('account.goodsNumber')
    }, {
      title: this.$t('account.shangpin'),
      dataIndex: 'productName',
      scopedSlots: {
        customRender: 'productName'
      }
    }, {
      title: this.$t('account.status'),
      dataIndex: 'productStatus',
      scopedSlots: {
        customRender: 'productStatus'
      }
    }, {
      title: this.$t('account.dyxCount'),
      dataIndex: 'erpCustomerNum'
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      search: {
        content: ''
      },
      data: [],
      columns: columns,
      moment: moment,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 10,
        current: 1,
        showSizeChanger: true
      },
      queryLoading: false
    };
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData(query) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.loadingTable = true;
              _this2.queryLoading = true;
              params = {
                productInfo: _this2.search.content,
                page: query ? 1 : _this2.pagination.current,
                size: _this2.pagination.pageSize
              };
              if (query) {
                _this2.pagination.current = 1;
              }
              _context.n = 1;
              return getGoodsVisibleList(params);
            case 1:
              res = _context.v;
              try {
                if (res.data.code == 200) {
                  _this2.data = res.data.data.list;
                  _this2.pagination.total = res.data.data.totalNum;
                }
              } catch (_unused) {} finally {
                _this2.loadingTable = false;
                _this2.queryLoading = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    add: function add() {
      this.$router.push({
        path: 'addGoodsVisible'
      });
    },
    Edit: function Edit(row) {
      this.$router.push({
        path: 'editGoodsVisible',
        query: {
          id: row.productOptionId
        }
      });
    },
    deleteGroup: function deleteGroup(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.loadingTable = true;
              _context2.n = 1;
              return deleteGoodsVisibleByid(row.productOptionId);
            case 1:
              res = _context2.v;
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.deleteSuccessfully'));
                _this3.initData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    queryList: function queryList() {
      this.initData(true);
    },
    cancelDelete: function cancelDelete() {},
    changePage: function changePage(e) {
      console.log('change');
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData();
    },
    goProduct: function goProduct(id) {
      var routeData = this.$router.resolve({
        path: '/productmanager/productDetail',
        query: {
          id: id
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
};